import { gql } from '__generated__'

export const GET_GUEST_SESSION = gql(`
  query getGuestSession {
    getGuestSession {
      id
      userId
      claimedAt
      expiresAt
    }
  }
`)
